import Vue from 'vue';
import Router from 'vue-router';
import Zt120v from "../views/industry/zt/zt120v.vue";
import Rjcp from "../views/industry/rjcp/index.vue";
Vue.use(Router);

const Index = () => import(/* webpackChunkName: 'Index' */ '@/views/index/index');
const NotFound = () => import(/* webpackChunkName: 'Index' */ '@/views/404');

const HW600 = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hw600');
const HW16V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hw16v');
const HW25V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hw25v');
const HW60V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hw60v');
const HW120V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hw120v');
const HW150V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hw150v');
const ZT25v = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt25v');
const ZT25vData = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt25vData');

const Polaris = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/polaris');
const Pod = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/pod');
const Digital = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/digital');
const Pilot = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/pilot');
const Link = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/link');
const Gimbal = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/gimbal');
const GimbalSpecial = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/gimbalSpecial');

const About = () => import(/* webpackChunkName: 'about' */ '@/views/about/index');
const Company = () => import(/* webpackChunkName: 'about' */ '@/views/about/company');
const Contact = () => import(/* webpackChunkName: 'about' */ '@/views/about/contact');
const ContactNew = () => import(/* webpackChunkName: 'about' */ '@/views/about/contactNew');
const privacyPolicy = () => import(/* webpackChunkName: 'about' */ '@/views/about/privacyPolicy');
const termsConditions = () => import(/* webpackChunkName: 'about' */ '@/views/about/termsConditions');
const After = () => import(/* webpackChunkName: 'about' */ '@/views/about/after');
const Join = () => import(/* webpackChunkName: 'join' */ '@/views/join/index');
const Campus = () => import(/* webpackChunkName: 'join' */ '@/views/join/campus');
const Social = () => import(/* webpackChunkName: 'join' */ '@/views/join/social');

const ZT120V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt/zt120v');
const ZT60VS = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt/zt60vs');
const ZT60V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt/zt60v');
const ZT25V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt/zt25v');
const ZT25VS = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt/zt25vs');
const ZT16V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt/zt16v');
const ZT13V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt/zt13v');
const HW25H = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt/hw25h');
const GDDC = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/rwzh/gddc');
const CHXJ = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/rwzh/chxj');
const JGLD = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/rwzh/jgld');
const FAYJ = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hyfa/fayj');
const FANY = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hyfa/fany');
const FALC = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hyfa/falc');
const FAGA = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hyfa/faga');
const FACH = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hyfa/fach');
const FASL = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hyfa/fasl');
const DMSB = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/dmsb/index');
const DMSB2 = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/dmsb/index');
const DMSB3 = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/dmsb/index');
const DMSB4 = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/dmsb/index');
const HYXW = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/hyxw/index');
const JOIN = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/join/index');
const YXXT = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/yxxt/index');
const FZXT = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/fzxt/index');
const RJCP = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/rjcp/index');

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/hw600',
      name: 'HW600',
      component: HW600
    },
    {
      path: '/hw16v',
      name: 'HW16V',
      component: HW16V
    },
    {
      path: '/hw25v',
      name: 'HW25V',
      component: ZT25v
    },
    {
      path: '/zt25v-data',
      name: 'zt25vData',
      component: ZT25vData
    },
    {
      path: '/hw60v',
      name: 'HW60V',
      component: HW60V
    },
    {
      path: '/hw120v',
      name: 'HW120V',
      component: HW120V
    },
    {
      path: '/hw150v',
      name: 'HW150V',
      component: HW150V
    },
    {
      path: '/polaris',
      name: 'polaris',
      component: Polaris
    },
    {
      path: '/pod',
      name: 'pod',
      component: Pod
    },
    {
      path: '/digital',
      name: 'digital',
      component: Digital
    },
    {
      path: '/pilot',
      name: 'Pilot',
      component: Pilot
    },
    {
      path: '/link',
      name: 'Link',
      component: Link
    },
    {
      path: '/gimbal',
      name: 'Gimbal',
      component: Gimbal
    },
    {
      path: '/gimbal-special',
      name: 'GimbalSpecial',
      component: GimbalSpecial
    },
    {
      path: '/about-us',
      name: 'aboutUs',
      component: About
    },
    {
      path: '/company',
      name: 'company',
      component: Company
    },
    {
      path: '/contact-us',
      name: 'contactUs',
      component: Contact
    },
    {
      path: '/contactUs',
      name: 'contact_us',
      component: ContactNew
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy
    },
    {
      path: '/termsConditions',
      name: 'termsConditions',
      component: termsConditions
    },
    {
      path: '/after-sale',
      name: 'afterSales',
      component: After
    },
    {
      path: '/join-us',
      name: 'joinUs',
      component: Join
    },
    {
      path: '/campus',
      name: 'campus',
      component: Campus
    },
    {
      path: '/social',
      name: 'social',
      component: Social
    },
    {
      path: '/zt120v',
      name: 'zt120v',
      component: ZT120V
    },
    {
      path: '/zt60vs',
      name: 'zt60vs',
      component: ZT60VS
    },
    {
      path: '/zt60v',
      name: 'zt60v',
      component: ZT60V
    },
    {
      path: '/zt25v',
      name: 'zt25v',
      component: ZT25V
    },
    {
      path: '/zt25vs',
      name: 'zt25vs',
      component: ZT25VS
    },
    {
      path: '/zt16v',
      name: 'zt16v',
      component: ZT16V
    },
    {
      path: '/zt13v',
      name: 'zt13v',
      component: ZT13V
    },
    {
      path: '/hw25h',
      name: 'hw25h',
      component: HW25H
    },
    {
      path: '/gddc',
      name: 'gddc',
      component: GDDC
    },
    {
      path: '/chxj',
      name: 'chxj',
      component: CHXJ
    },
    {
      path: '/jgld',
      name: 'jgld',
      component: JGLD
    },
    {
      path: '/fayj',
      name: 'fayj',
      component: FAYJ
    },
    {
      path: '/fany',
      name: 'fany',
      component: FANY
    },
    {
      path: '/falc',
      name: 'falc',
      component: FALC
    },
    {
      path: '/faga',
      name: 'faga',
      component: FAGA
    },
    {
      path: '/fach',
      name: 'fach',
      component: FACH
    },
    {
      path: '/fasl',
      name: 'fasl',
      component: FASL
    },
    {
      path: '/dmsb',
      name: 'dmsb',
      component: DMSB
    },
    {
      path: '/dmsb2',
      name: 'dmsb2',
      component: DMSB2
    },
    {
      path: '/dmsb3',
      name: 'dmsb3',
      component: DMSB3
    },
    {
      path: '/dmsb4',
      name: 'dmsb4',
      component: DMSB4
    },
    {
      path: '/hyxw',
      name: 'hyxw',
      component: HYXW
    },
    {
      path: '/join',
      name: 'join',
      component: JOIN
    },
    {
      path: '/join2',
      name: 'join2',
      component: JOIN
    },
    {
      path: '/yxxt',
      name: 'yxxt',
      component: YXXT
    },
    {
      path: '/fzxt',
      name: 'fzxt',
      component: FZXT
    },
    {
      path: '/rjcp',
      name: 'rjcp',
      component: RJCP
    },
    {
      path: '/rjcp2',
      name: 'rjcp2',
      component: RJCP
    },
    {
      path: '/rjcp3',
      name: 'rjcp3',
      component: RJCP
    },
    {
      path: '/not-found',
      name: 'notFound',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/not-found'
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js